import { Component, Input, OnInit, SimpleChanges, ViewContainerRef } from '@angular/core'
import { NzModalService } from 'ng-zorro-antd/modal'
import { QueryTableLeave } from 'src/app/services/interface/general.model'
import { NzTableQueryParams } from 'ng-zorro-antd/table'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { NzNotificationService } from 'ng-zorro-antd/notification'
import { NzButtonSize } from 'ng-zorro-antd/button'
import { LeaveManagementService } from 'src/app/services/leave-management/leave-management.service'
import { AnnualLeaveType } from 'src/app/services/interface/leave-management/leave.model'
import { ViewDetailSpecialLeaveComponent } from '../view-detail-special-leave/view-detail-special-leave.component'

@Component({
  selector: 'app-tab-cancelled-special-leave',
  templateUrl: './tab-cancelled-special-leave.component.html',
  //   styleUrls: ['./annual-leave.component.scss'],
})
export class TabCancelledSpecialLeaveComponent implements OnInit {
  @Input() selectedType: string | null = null

  size: NzButtonSize = 'large'
  status = ''

  listOfData: AnnualLeaveType[] = []
  selectedFilter = 'CANCELED'
  // selectedType = null
  isLoading: boolean = true
  totalData: number = 0
  pageSize: number = 5
  pageIndex: number = 1
  isAnnualLeave = false

  form: FormGroup
  constructor(
    private modal: NzModalService,
    private viewContainerRef: ViewContainerRef,
    private fb: FormBuilder,
    private notification: NzNotificationService,
    private leaveManagementService: LeaveManagementService,
  ) {
    this.form = this.fb.group({
      keyword: [null, Validators.compose([Validators.required])],
      prefix: ['vendor', Validators.compose([Validators.required])],
    })
  }

  queryTable: QueryTableLeave = {
    sort: { field: null, order: null },
    annual_leave: true,
    pageSize: this.pageSize,
    pageIndex: this.pageIndex - 1,
  }

  listOfColumns = [
    {
      name: 'ID',
      key: 'id',
      sortOrder: null,
      sortFn: null,
      listOfFilter: [],
      filterFn: null,
      left: true,
      right: false,
      width: '30px',
    },
    {
      name: 'Actions',
      key: 'actions',
      sortOrder: null,
      sortFn: null,
      listOfFilter: [],
      filterFn: null,
      left: true,
      right: false,
      width: '40px',
    },
    {
      name: 'Leave Type',
      key: 'type',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: false,
      width: '50px',
    },
    {
      name: 'Total Leave',
      key: 'total_leave',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: false,
      width: '50px',
    },
    {
      name: 'Date of Leave',
      key: 'date',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: false,
      width: '30px',
    },
    {
      name: 'Date of In',
      key: 'join_date',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: false,
      width: '50px',
    },
    {
      name: 'Status',
      key: 'status',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: false,
      width: '50px',
    },
    {
      name: 'Notes',
      key: 'notes_approval',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: false,
      width: '50px',
    },
  ]

  ngOnInit(): void {
    this.fetchAnnualLeaveList()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedType']) {
      this.fetchAnnualLeaveList()
    }
  }

  fetchAnnualLeaveList() {
    this.isLoading = true
    this.leaveManagementService
      .getAnnualLeaveList(
        this.selectedFilter,
        this.queryTable,
        this.isAnnualLeave,
        this.selectedType,
      )
      .subscribe(
        (r: any) => {
          this.isLoading = false
          // this.listOfData = r.rows
          this.listOfData = r.rows.map((item: any) => ({
            ...item,
            status: this.transformStatus(item.status),
          }))

          this.totalData = r.count
        },
        (error: any) => {
          this.isLoading = false
        },
      ),
      err => {
        this.fetchAnnualLeaveList()
      }
  }

  transformStatus(status: string): string {
    switch (status) {
      // case 'WAITING':
      //   return 'Waiting for Approval'
      case 'CANCELED':
        return 'Canceled'
      case 'APPROVED':
        return 'Approved'
      default:
        return status
    }
  }

  viewDetailLeave(leaveId: string) {
    const modal = this.modal.create({
      nzTitle: 'View Detail Special Leave',
      nzContent: ViewDetailSpecialLeaveComponent,
      nzStyle: { top: '50px' },
      nzViewContainerRef: this.viewContainerRef,
      nzComponentParams: {
        leaveId: leaveId,
        selectedFilter: this.selectedFilter,
      },
      nzMaskClosable: false,
      // nzFooter: [
      //   {
      //     label: 'Close',
      //     danger: true,
      //     onClick() {
      //       modal.destroy()
      //     },
      //   },
      // ],
      nzWidth: '50%',
    })
    modal.afterClose.subscribe(() => this.fetchAnnualLeaveList())
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    const { pageSize, pageIndex, sort } = params
    this.queryTable.pageSize = pageSize
    this.queryTable.pageIndex = pageIndex - 1
    const currentSort = sort.find(item => item.value !== null)
    const sortField = (currentSort && currentSort.key) || null
    const sortOrder = (currentSort && currentSort.value) || null

    if (sortField != null && sortOrder != null) {
      this.queryTable.sort = {
        field: sortField,
        order: sortOrder,
      }
    } else {
      this.queryTable.sort = { field: null, order: null }
    }

    this.fetchAnnualLeaveList()
  }
}
